import { APIcallerv2 } from './APIcaller';

export const getIntegrationsWithClientConfig = () => APIcallerv2.apiGet('/integrations/client');

export const getIntegrationsWithStoreConfig = (storeId) =>
  APIcallerv2.apiGet(`/integrations/store/${storeId}`);

/**
 * Fetches the OAuth2 authorization redirect URL for a partner (no redirect is performed).
 * @param {string} partnerId - UUID of the integration partner
 * @param {string} [returnPath] - Path to redirect to after OAuth callback (default: /admin/integrations)
 * @param {string} [storeId] - Optional store UUID when connecting a store-scoped integration
 * @returns {Promise<string>} The URL to redirect the user to for OAuth2 consent
 */
export const getOauth2RedirectUrl = (partnerId, returnPath, storeId) => {
  const params = { partnerId, returnPath };

  if (storeId) {
    params.storeId = storeId;
  }

  return APIcallerv2.apiGet('/integrations/oauth2/redirect', params, 'text');
};

/**
 * Disconnects an integration for a partner (client-level or store-level config).
 * Query params are required by the API; the shared apiPost helper sends a JSON body only.
 * @param {string} partnerId - UUID of the integration partner
 * @param {string} [storeId] - Optional store UUID when disconnecting a store-scoped integration
 * @returns {Promise<unknown>}
 */
export const disconnectIntegration = (partnerId, storeId) => {
  const query = new URLSearchParams({ partnerId });

  if (storeId) {
    query.set('storeId', storeId);
  }

  return APIcallerv2.apiPost(`/integrations/disconnect?${query.toString()}`, {});
};

export const getIntegrationExternalEntities = (partnerConfigId) =>
  APIcallerv2.apiGet(`/integrations/partner-config/${partnerConfigId}/external-entities`);

export const getIntegrationMappings = (partnerId, storeId) => {
  const params = storeId ? { storeId } : {};

  return APIcallerv2.apiGet(`/integrations/${partnerId}/mappings`, params);
};

export const saveIntegrationMappings = (partnerId, mappings, storeId) => {
  const query = storeId ? `?storeId=${storeId}` : '';

  return APIcallerv2.apiPost(`/integrations/${partnerId}/mappings${query}`, { mappings });
};

export const saveIntegrationToken = (partnerId, token, storeId) => {
  const query = storeId ? `?storeId=${storeId}` : '';

  return APIcallerv2.apiPost(`/integrations/${partnerId}/token${query}`, { token });
};

/**
 * Triggers a payroll (masse salariale) re-synchronisation over a date range for the given stores.
 * Proxied server-side to the DATA API; the client id is derived from the authenticated account,
 * so it is not sent from the front end.
 *
 * @param {Object} params
 * @param {String} params.startDate - Range start, formatted YYYY-MM-DD
 * @param {String} params.endDate   - Range end, formatted YYYY-MM-DD
 * @param {String[]} params.storeIds - Ids of the stores mapped to HR establishments to synchronise
 * @returns {Promise<unknown>}
 */
export const syncPayroll = ({ startDate, endDate, storeIds }) =>
  APIcallerv2.apiPost('/integrations/payroll-synchro', { startDate, endDate, storeIds });
